import { composables } from "@orange-marmalade/paginate-this";
import _ from "lodash";
import { toastr } from "react-redux-toastr";
import api from "APP_ROOT/api";
import { SUCCESS } from "LIB/submission";

export const pgActions = composables({ listId: "company/contacts" });

export function createContact(contact) {
  return (dispatch, getState) => {
    const companyId = getState().companyDetail.getIn(["company", "id"]);
    return api.companies.contacts.create(companyId, contact).then(() => {
      dispatch(pgActions.expire());
      return SUCCESS;
    });
  };
}

export function updateContact(contact) {
  return dispatch =>
    api.contacts.update(contact).then(() => {
      dispatch(pgActions.expire());
      return SUCCESS;
    });
}

export function destroyContact(id) {
  return dispatch =>
    api.contacts
      .destroy(id)
      .then(() => dispatch(pgActions.expire()))
      .catch(error => {
        // Its possible that the delete will fail due to the contact being associated with other records.
        // This toastr error helps the user understand exactly why the delete failed since there's been confusion on it in the past.
        toastr.error(
          "Error",
          _.get(error, "errors.base[0]"),
          "Unexpected error"
        );
      });
}



// WEBPACK FOOTER //
// ./app/modules/companies/actions/contacts/actions.js